import { render, staticRenderFns } from "./NewVsReturning.vue?vue&type=template&id=52803626&"
import script from "./NewVsReturning.vue?vue&type=script&lang=js&"
export * from "./NewVsReturning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports